/* eslint-disable react/jsx-one-expression-per-line */
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Header from "./header";
import SlideOutCart from "./cart/SlideOutCart";
import Footer from "./footer";
import NewsletterSubscription from "./newsletter-subscription";
import StructuredBase from "./structured-data/StructuredBase";
import { Helmet } from "react-helmet";
import Impact from "../components/impact/universalTracking";

const Layout = ({ children, pageClassName, newsletterType }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      datoCmsSite {
        faviconMetaTags {
          tags
        }
      }
    }
  `);
  const faviconLinks =
    data.datoCmsSite.faviconMetaTags?.tags.filter(
      (tag) => tag.tagName === "link"
    ) || [];
  if (typeof window !== "undefined") {
    // eslint-disable-next-line global-require
    require("smooth-scroll")('a[href*="#"]', {
      speed: 500,
      speedAsDuration: true,
      updateURL: true,
      offset: 150,
    });
  }

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <div className={`relative ${pageClassName}`}>
      <Helmet link={faviconLinks.map((link) => link.attributes)}>
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=3154db33-6792-4fbb-8016-b6a52447a075"
        ></script>
        <script src="https://js.hsforms.net/forms/v2.js"></script>
        <script
          async
          src="https://www.tintup.com/app/dist/embedded.js"
        ></script>
      </Helmet>
      <Impact />
      <StructuredBase />
      <SlideOutCart />
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>
        <main>{children}</main>
        <NewsletterSubscription newsletterType={newsletterType} />
        <Footer />
      </div>
    </div>
  );
};

Layout.propTypes = { children: PropTypes.node.isRequired };

export default Layout;
